import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import Curriculumleft from './Curriculumleft'


const Mtech_curriculumEle = () => {
    const curriculumData = [
        {
            department: "Chemical Engineering",
            specializations: [
                {
                    name: "Chemical Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/CH M.Tech Curriculum.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Civil and Environmental Engineering",
            specializations: [
                {
                    name: "Environmental and Water Resources Engineering",
                    curricula: [
                        {
                            batch: "2020 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-EWRE-2020-21.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/MTechCurriculum-EWRE.pdf",
                        },
                    ],
                },
                {
                    name: "Geotechnical Engineering",
                    curricula: [
                        {
                            batch: "2020 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-GTE-2020-21.pdf",
                        },
                    ],
                },
                {
                    name: "Structural Engineering",
                    curricula: [
                        {
                            batch: "2020 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-SE-2020-21.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/MTechCurriculum-SE.pdf",
                        },
                    ],
                },
                {
                    name: "Transportation and Infrastructure Engineering",
                    curricula: [
                        {
                            batch: "2020 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-TIE-2020-21.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/MTechCurriculum-TIE.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Computer Science & Engineering",
            specializations: [
                {
                    name: "Computer Science & Engineering",
                    curricula: [
                        {
                            batch: "2020 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-CSE-2020-21.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/images/demo/iit/curriculums/2018/Mtech/M.Tech_Curriculum_CSE.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2019/M.Tech_Curriculum_CSE_2018.pdf",
                        },
                    ],
                },
                {
                    name: "Data Science & Artificial Intelligence",
                    curricula: [
                        {
                            batch: "2025 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech_DSAI.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Electrical Engineering",
            specializations: [
                {
                    name: "Signal Processing, Communication & Machine Learning",
                    curricula: [
                        {
                            batch: "2025 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2024/M.Tech/M_Tech_SPCML.pdf",
                        },
                    ],
                },
                {
                    name: "Microelectronics & VLSI",
                    curricula: [
                        {
                            batch: "2025-2026",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-MVLSI-2025-26.pdf",
                        },
                        {
                            batch: "2021-2022",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-MVLSI-2021-22.pdf",
                        },
                    ],
                },
                {
                    name: "RF & Microwave Engineering",
                    curricula: [
                        {
                            batch: "2022-2023",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-RFMWE-2022-23.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Mechanical Engineering",
            specializations: [
                {
                    name: "Computational Mechanics",
                    curricula: [
                        {
                            batch: "2026 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/Computational_Mechanics_MTech _23_03_26.pdf",
                        },
                    ],
                },
                {
                    name: "Design & Manufacturing",
                    curricula: [
                        {
                            batch: "Indian Army Officers (2020 Batch Onwards)",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-DM-Army%20Officers-2020-21.pdf",
                        },
                        {
                            batch: "2020 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/M.Tech-DM-2020-21_12_12_2024.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2019/M.Tech_Curriculum_ME.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/images/demo/iit/curriculums/2018/Mtech/M.Tech_Curriculum_ME.pdf",
                        },
                    ],
                },
                {
                    name: "Thermal Engineering and Energy Systems",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/M.Tech/TEES_M_Tech_18_2_26.pdf",
                        },
                    ],
                },
            ],
        },
    ];


    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Curriculumleft activeIndex={1} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>
                        <h3 className='text-center mb-5'>M.Tech. Curriculum</h3>
                        <h5>Curriculum for M.Tech. Programs are listed as below:</h5>

                        <div className="table-responsive mt-4">
                            <table className="table table-bordered table-hover align-middle">
                                <thead className="table-primary text-center">
                                    <tr>
                                        <th width="8%">S.No.</th>
                                        <th width="25%">Department</th>
                                        <th width="32%">Specialization</th>
                                        <th width="35%">Batch</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {curriculumData.map((dept, deptIndex) => {
                                        const deptRowSpan = dept.specializations.reduce(
                                            (total, spec) => total + spec.curricula.length,
                                            0
                                        );

                                        let isFirstDepartmentRow = true;

                                        return dept.specializations.flatMap((spec, specIndex) =>
                                            spec.curricula.map((item, itemIndex) => {
                                                const row = (
                                                    <tr
                                                        key={`${deptIndex}-${specIndex}-${itemIndex}`}
                                                        className={
                                                            deptIndex % 2 === 0
                                                                ? "table-light"
                                                                : "table-secondary"
                                                        }
                                                    >
                                                        {/* Department */}
                                                        {isFirstDepartmentRow && (
                                                            <>
                                                                <td
                                                                    rowSpan={deptRowSpan}
                                                                    className="text-center align-middle fw-bold"
                                                                >
                                                                    {deptIndex + 1}
                                                                </td>

                                                                <td
                                                                    rowSpan={deptRowSpan}
                                                                    className="align-middle fw-bold"
                                                                >
                                                                    {dept.department}
                                                                </td>
                                                            </>
                                                        )}

                                                        {/* Specialization */}
                                                        {itemIndex === 0 && (
                                                            <td
                                                                rowSpan={spec.curricula.length}
                                                                className="align-middle"
                                                            >
                                                                {spec.name}
                                                            </td>
                                                        )}

                                                        {/* Batch */}
                                                        <td>
                                                            <Link
                                                                to={item.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-decoration-none"
                                                            >
                                                                <i className="fas fa-file-pdf text-danger me-2"></i>
                                                                {item.batch}
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                );

                                                isFirstDepartmentRow = false;
                                                return row;
                                            })
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>

    );
};


export default Mtech_curriculumEle;
